// extracted by mini-css-extract-plugin
export var legendIndicator = "_fj-1";
export var legendRight = "_fj-0";